
import { Line } from 'vue-chartjs'

export default {

   extends: Line,

   props: {
      data: Object,
      options: Object,
      version: Number,  // change it to update view
   },

   mounted () {
      this.renderChart(this.data, this.options)
   },

   watch: {
      version (val) {
         //console.log('version', val, 'data', this.data)
         this.renderChart(this.data, this.options)
      },
   }
}



// WEBPACK FOOTER //
// ./src/components/users/LineChart.js